import { useEffect, useState } from "react";
import api from "../api";

const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

export const FunnelStats = () => {
  const [s, setS] = useState(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => { api.get("/drip/stats-overview").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;

  const steps = showAll ? s.steps : s.steps.filter((x) => x.in_attesa_qui || x.inviate);
  return (
    <div className="panel" style={{ marginTop: 16 }} data-testid="funnel-stats">
      <div className="toolbar">
        <h3 style={{ margin: 0 }}>📊 Statistiche funnel</h3>
        <div className="spacer" />
        <button className="btn sm" onClick={() => setShowAll(!showAll)} data-testid="funnel-stats-toggle">
          {showAll ? "Solo tappe con attività" : "Mostra tutte le tappe"}
        </button>
      </div>
      <div className="tag-filter" style={{ margin: "10px 0" }}>
        <span className="chip" style={{ background: "#16a34a" }} data-testid="funnel-stats-active">In cammino: {s.attivi}</span>
        <span className="chip" style={{ background: "#2563eb" }} data-testid="funnel-stats-completed">Hanno completato: {s.completati}</span>
        <span className="chip" style={{ background: "#64748b" }} data-testid="funnel-stats-stopped">Fermati: {s.fermati}</span>
      </div>
      <table>
        <thead><tr><th>#</th><th>Newsletter</th><th>Prossima da ricevere per</th><th>Inviate</th><th>Aperte</th></tr></thead>
        <tbody>
          {steps.map((x) => (
            <tr key={x.idx} data-testid={`funnel-step-${x.idx}`}>
              <td>{x.idx + 1}</td>
              <td>{x.title}</td>
              <td>{x.in_attesa_qui ? <b>{x.in_attesa_qui} {x.in_attesa_qui === 1 ? "persona" : "persone"}</b> : <span className="muted">—</span>}</td>
              <td>{x.inviate || <span className="muted">—</span>}</td>
              <td>{x.inviate ? `${x.aperte} (${pct(x.aperte, x.inviate)}%)` : <span className="muted">—</span>}</td>
            </tr>
          ))}
          {steps.length === 0 && <tr><td colSpan={5}><div className="empty">Nessuna attività ancora.</div></td></tr>}
        </tbody>
      </table>

      {s.top_readers?.length > 0 && (
        <>
          <h4 style={{ margin: "18px 0 6px" }}>🏆 Chi apre di più</h4>
          <table>
            <thead><tr><th>Nome</th><th>Email</th><th>Ricevute</th><th>Aperte</th><th>Clic</th></tr></thead>
            <tbody>
              {s.top_readers.slice(0, 10).map((r) => (
                <tr key={r.email} data-testid={`funnel-reader-${r.email}`}>
                  <td>{r.name || "—"}</td><td>{r.email}</td>
                  <td>{r.inviate}</td><td><b>{r.aperte}</b> ({pct(r.aperte, r.inviate)}%)</td><td>{r.clic}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <p className="muted" style={{ fontSize: 12, marginTop: 8 }}>Le aperture sono rilevate col pixel di tracciamento: alcuni client email le nascondono, quindi i numeri reali possono essere leggermente più alti.</p>
    </div>
  );
};

export default FunnelStats;
